export class PhoneNumberModel {
  id: number;
  accountSid: string;
  authToken: string;
  phoneNumber: string;
  assignedAgent: string;
}
